import { selectIsRightBarVisible } from "@v1/selectors/ui";
import { useEditorSelector } from "@v1/store/store";

export default function useRightBarVisibility() {
  return useEditorSelector(selectIsRightBarVisible);
}
